import { createContext, useContext } from "react";
import type { Ambiente } from "./api";

/** O que o ambiente liga (vem de /v1/admin/capacidades). Telas de teste somem em producao. */
export type Contexto = { ambiente: Ambiente; modulos: string[]; ferramentasDeTeste: boolean };
export const AmbienteCtx = createContext<Contexto>({ ambiente: "local", modulos: [], ferramentasDeTeste: false });
export const useAmbiente = () => useContext(AmbienteCtx);

/**
 * A plataforma (Profit One / Profit Pro) e da Nelogica V1, que so a Prop liga. Na Global ela NAO EXISTE: nem nos
 * planos, nem no checkout, nem no registro de uma compra. Perguntar pelo MODULO, e nao pela moeda, porque uma
 * vitrine em real na Global traria o campo de volta (o checkout em dolar ja tinha sido tampado pela moeda em 23/09).
 */
export const temPlataformaProfit = (modulos: string[]) => modulos.includes("nelogica-v1");
